import '../styles/web-express.scss';
import initPageChrome from './page-chrome';

document.addEventListener('DOMContentLoaded', initPageChrome);
